import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { StatusFilterValue } from '../authorisations/slice';

type RootWarrantiesState = {
  mainFilters: {
    status: StatusFilterValue;
  };
};
const initialState: RootWarrantiesState = {
  mainFilters: {
    status: 'actives',
  },
};

export const warrantiesSlice = createSlice({
  name: 'warranties',
  initialState,
  reducers: {
    statusChanged: (state, { payload }: PayloadAction<{ status: StatusFilterValue }>) => {
      state.mainFilters.status = payload.status;
    },
  },
  selectors: {
    status: (state) => state.mainFilters.status,
  },
});

export const warrantiesSelectors = warrantiesSlice.selectors;
export const warrantiesActions = warrantiesSlice.actions;
